import { useEffect, useState } from 'react';
import { Avatar, Card, Col, Row, Spin, Tag, Typography } from 'antd';
import { UserOutlined, CheckCircleFilled } from '@ant-design/icons';
import { useAuth } from '../context/AuthContext';
import { fetchMyCompany, Company } from '../api/network';

const { Title, Text, Paragraph } = Typography;

export default function MyProfile() {
  const { token } = useAuth();
  const [company, setCompany] = useState<Company | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) return;
    fetchMyCompany(token).then(c => { setCompany(c); setLoading(false); });
  }, [token]);

  if (loading) {
    return <div style={{ padding: 48, textAlign: 'center' }}><Spin size="large" /></div>;
  }

  if (!company) {
    return (
      <div style={{ padding: 24 }}>
        <Title level={3} style={{ marginBottom: 16 }}>My Business Profile</Title>
        <Card>
          <Text type="secondary">
            You don't have a business profile yet.{' '}
            <a href="https://urbanlife.works/dashboard/company" target="_blank" rel="noreferrer">
              Create your company profile
            </a>{' '}
            on the UrbanLife.Works platform.
          </Text>
        </Card>
      </div>
    );
  }

  return (
    <div style={{ padding: 24 }}>
      <Title level={3} style={{ marginBottom: 24 }}>My Business Profile</Title>
      <Card>
        <Row gutter={24} align="middle">
          <Col>
            {company.logo_url
              ? <Avatar size={80} src={company.logo_url} />
              : <Avatar size={80} icon={<UserOutlined />} style={{ background: '#1677ff' }} />
            }
          </Col>
          <Col flex={1}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <Title level={4} style={{ margin: 0 }}>{company.name}</Title>
              {company.is_verified && <CheckCircleFilled style={{ color: '#1677ff', fontSize: 18 }} />}
            </div>
            <div style={{ marginTop: 4, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <Tag color="blue">{company.company_type.replace('_', ' ')}</Tag>
              {company.city && <Text type="secondary">{company.city}{company.country ? `, ${company.country}` : ''}</Text>}
            </div>
          </Col>
        </Row>

        {company.description && (
          <Paragraph style={{ marginTop: 16 }}>{company.description}</Paragraph>
        )}

        <Row gutter={16} style={{ marginTop: 16 }}>
          {company.founded_year && <Col><Text type="secondary">Founded: </Text><Text>{company.founded_year}</Text></Col>}
          {company.employee_count && <Col><Text type="secondary">Size: </Text><Text>{company.employee_count}</Text></Col>}
          {company.website && <Col><a href={company.website} target="_blank" rel="noreferrer">{company.website}</a></Col>}
        </Row>
      </Card>
    </div>
  );
}
